/* import __COLOCATED_TEMPLATE__ from './appointments-subs-plan-card.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { APPOINTMENTS_FREE_TOKEN, APPOINTMENTS_PLUS_TOKEN, APPOINTMENTS_PREMIUM_TOKEN } from '@square/appointments-feature-upsell/services/appointments-feature-info';

/**
 * AppointmentsSubsPlanCard Component
 *
 * This component displays basic title, description, and price for an appointments subscription
 * plan, as well as a CTA button.
 */
let AppointmentsSubsPlanCard = (_class = class AppointmentsSubsPlanCard extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
  }
  get buttonRank() {
    if (this.plan.isFree) {
      return 'secondary';
    }
    return 'primary';
  }
  get buttonText() {
    if (this.isActive) {
      return this.intl.t('apptsUpsell.subscription.plans.currentPlan');
    }
    if (this.plan.isFree) {
      return this.intl.t('apptsUpsell.common.getStarted');
    }
    return this.plan.freeTrialDaysLeft > 0 ? this.intl.t('apptsUpsell.subscription.startFreeTrial') : this.intl.t('apptsUpsell.subscription.subscribe');
  }
  get formattedPrice() {
    const formattedPrice = this.formatter.currency(this.plan.priceInCent, this.plan.currencyCode, {
      maximumFractionDigits: 0
    } // no decimal places in subscription price
    );
    return formattedPrice;
  }
  get isActive() {
    return this.args.activeSubscriptionPlan && this.plan.token === this.args.activeSubscriptionPlan;
  }
  get perMonthString() {
    // price is hardcoded to an empty string because the price is a separate string
    return this.intl.t('apptsUpsell.subscription.plan.price.perMonth', {
      price: ''
    });
  }
  get plan() {
    return this.args.plan ?? {};
  }
  get planDescription() {
    switch (this.plan.token) {
      case APPOINTMENTS_FREE_TOKEN:
        return this.intl.t('apptsUpsell.subscription.description.free');
      case APPOINTMENTS_PLUS_TOKEN:
        return this.intl.t('apptsUpsell.subscription.description.plus');
      case APPOINTMENTS_PREMIUM_TOKEN:
        return this.intl.t('apptsUpsell.subscription.description.premium');
      default:
        return '';
    }
  }
  get planUnit() {
    return this.plan.isFree ? this.intl.t('apptsUpsell.subscription.plan.unit.free') : this.intl.t('apptsUpsell.subscription.plan.unit.paid');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AppointmentsSubsPlanCard as default };